import {
  OVERSTAY_CHARGES_LOAD_REQUEST,
  OVERSTAY_CHARGES_LOAD_SUCCESS,
  OVERSTAY_CHARGES_LOAD_FAILURE,
  OVERSTAY_CHARGE_EDIT_START,
  OVERSTAY_CHARGE_EDIT_CANCEL,
  OVERSTAY_CHARGE_SAVE_SUCCESS,
} from '../actions/overstayCharge';

const initialState = {
  overstayCharges: [],
  loaded: false,
  editing: {},
  loading_overstayCharges: false,
};

function initializeState(){
  return Object.assign({}, initialState);
}

export default function overstayCharge(state = initializeState(), action = {}) {
  switch (action.type) {
    case OVERSTAY_CHARGES_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        loading_overstayCharges: true,
      };
    case OVERSTAY_CHARGES_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        overstayCharges: action.overstayCharges,
        error: null,
        loading_overstayCharges: false,
      };
    case OVERSTAY_CHARGES_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        overstayCharges: null,
        error: action.error,
        loading_overstayCharges: false,
      };
    case OVERSTAY_CHARGE_EDIT_START:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: true
        }
      };
    case OVERSTAY_CHARGE_EDIT_CANCEL:
      return {
        ...state,
        editing: {
          ...state.editing,
          [action.id]: false
        }
      };

    case OVERSTAY_CHARGE_SAVE_SUCCESS:
      let overstayCharges = [...state.overstayCharges];
      let overstayChargeData = [];
      for (const [index, overstayCharge] of overstayCharges.entries()) {
        if (overstayCharge.id === action.id) {
          overstayChargeData = [
            ...overstayCharges.slice(0, index),
            action.overstayCharge,
            ...overstayCharges.slice(index + 1)
          ];
        }
      }
      return {
        ...state,
        overstayCharges: overstayChargeData,
        loading_overstayCharges: false,
        editing: {
          ...state.editing,
          [action.id]: false
        },
      };

    case 'OVERSTAY_CHARGE_SAVE_REQUEST':
      return {
        ...state,
        loading_overstayCharges: true,
      }

    default:
      return state;
  }
}
